import { Link } from 'react-router-dom';
import { HelpIllustration } from '../components/HelpIllustration';
import { illustrations } from '../content/illustrations';

const guideSections = [
  {
    title: '兑换前先确认账号',
    body: '优先使用没有现有会员、没有家庭组、没有受管理员控制方案的账号。多个账号同时登录时，要确认兑换页面选择的是目标账号。',
    illustration: illustrations.account,
  },
  {
    title: '地区不可用不一定是链接问题',
    body: '先检查 Gemini 网页：如果打不开，再看谷歌搜索页底部识别的地区，确认当前网络被如何识别；如果可以打开，就直接查看官方条款页显示的账号关联地区。网络识别与账号关联是两项独立信息。',
    illustration: illustrations.region,
  },
  {
    title: '账号地区显示中国时可以提交官方申请',
    body: '可以通过 Google 官方地区关联表单提交调整请求，按页面要求操作并等待审核邮件。是否能够调整以官方审核为准，不保证每个账号都能通过。',
    illustration: illustrations.countryAssociationFormExample,
  },
  {
    title: '付款资料操作有风险',
    body: '国内付款资料可能影响活动资格，但删除资料也可能影响现有订阅、余额和付款服务。优先考虑换用符合条件的其他账号。',
    illustration: illustrations.payment,
  },
  {
    title: '会员不等于 API 或第三方工具资格',
    body: 'API、AI Studio、反重力和第三方客户端有独立的地区、配额、计费和账号规则，不能用它们是否可用来判断会员兑换是否成功。',
    illustration: illustrations.membership,
  },
  {
    title: '期限与售后范围',
    body: '兑换页面可能显示 18 个月，但实际使用期限受官方账号状态和上游活动资格影响。页面只帮助排查，不自行承诺售后结论。',
    illustration: illustrations.errors,
  },
];

export function GuidePage() {
  return (
    <div className="page article-page">
      <header className="article-hero">
        <span className="eyebrow">完整教程</span>
        <h1>先确认会员是否生效，再判断是哪一类问题。</h1>
        <p>下面是所有诊断流程都遵守的原则。遇到具体问题时，使用问答向导会更快。</p>
        <Link className="primary-button compact-button" to="/">开始自助排查</Link>
      </header>
      <div className="guide-stack">
        {guideSections.map((section, index) => (
          <section className="guide-section" key={section.title}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            <div>
              <h2>{section.title}</h2>
              <p>{section.body}</p>
              <HelpIllustration illustration={section.illustration} />
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
